import { Box, Typography } from '@mui/material';
import ProgressBarLayout from '@Router/Landing/Components/ProgressBar/ProgressBarLayout';
import { getStatusFromProgress, IProgress } from '../../utils';

type ProgressBarDetailsProps = {
  title: string;
  id?: number;
  progressData?: IProgress[];
  isPublished: boolean;
};

const ProgressBarDetails = ({
  title,
  id,
  progressData,
  isPublished,
}: ProgressBarDetailsProps) => {
  return (
    <Box p={1}>
      <Typography fontWeight="bold" ml={2}>
        {title}
      </Typography>
      {progressData?.map((item, index) => (
        <ProgressBarLayout
          key={index}
          status={getStatusFromProgress(item.progress || 0)}
          title={item.title}
          progress={item?.progress || 0}
          path={item.path}
          id={id}
          isPublished={isPublished}
        />
      ))}
    </Box>
  );
};
export default ProgressBarDetails;
